// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
import ___CSS_LOADER_AT_RULE_IMPORT_0___ from "-!../../../../node_modules/css-loader/dist/cjs.js!../../../css/App.css";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
___CSS_LOADER_EXPORT___.i(___CSS_LOADER_AT_RULE_IMPORT_0___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.report-container {
    max-width: 700px;
    margin: 0 auto;
    padding: 2rem;
}

.report-title {
    margin-bottom: 1.5rem;
    text-align: center;
}

.report-intro {
    margin-bottom: 1.5rem;
    line-height: 1.6;
}

.report-form {
    display: flex;
    flex-direction: column;
    gap: 1.25rem;
}

.report-label {
    display: flex;
    flex-direction: column;
    font-weight: 600;
}

.report-textarea {
    margin-top: 0.5rem;
    min-height: 140px;
    padding: 0.75rem;
    font-size: 1rem;
    border: 1px solid #ccc;
    border-radius: 6px;
    resize: vertical;
}

.report-input {
    margin-top: 0.5rem;
    padding: 0.75rem;
    font-size: 1rem;
    border: 1px solid #ccc;
    border-radius: 6px;
}

.report-button {
    padding: 0.9rem 1.5rem;
    font-size: 1.1rem;
    background: #0066cc;
    border: none;
    border-radius: 6px;
    cursor: pointer;
}

    .report-button:disabled {
        opacity: 0.6;
        cursor: default;
    }

.report-confirmation {
    text-align: center;
    line-height: 1.6;
}
`, "",{"version":3,"sources":["webpack://./src/assets/Documents/css/ReportIssue.css"],"names":[],"mappings":"AAEA;IACI,gBAAgB;IAChB,cAAc;IACd,aAAa;AACjB;;AAEA;IACI,qBAAqB;IACrB,kBAAkB;AACtB;;AAEA;IACI,qBAAqB;IACrB,gBAAgB;AACpB;;AAEA;IACI,aAAa;IACb,sBAAsB;IACtB,YAAY;AAChB;;AAEA;IACI,aAAa;IACb,sBAAsB;IACtB,gBAAgB;AACpB;;AAEA;IACI,kBAAkB;IAClB,iBAAiB;IACjB,gBAAgB;IAChB,eAAe;IACf,sBAAsB;IACtB,kBAAkB;IAClB,gBAAgB;AACpB;;AAEA;IACI,kBAAkB;IAClB,gBAAgB;IAChB,eAAe;IACf,sBAAsB;IACtB,kBAAkB;AACtB;;AAEA;IACI,sBAAsB;IACtB,iBAAiB;IACjB,mBAAmB;IACnB,YAAY;IACZ,kBAAkB;IAClB,eAAe;AACnB;;IAEI;QACI,YAAY;QACZ,eAAe;IACnB;;AAEJ;IACI,kBAAkB;IAClB,gBAAgB;AACpB","sourcesContent":["@import '../../../css/App.css';\r\n\r\n.report-container {\r\n    max-width: 700px;\r\n    margin: 0 auto;\r\n    padding: 2rem;\r\n}\r\n\r\n.report-title {\r\n    margin-bottom: 1.5rem;\r\n    text-align: center;\r\n}\r\n\r\n.report-intro {\r\n    margin-bottom: 1.5rem;\r\n    line-height: 1.6;\r\n}\r\n\r\n.report-form {\r\n    display: flex;\r\n    flex-direction: column;\r\n    gap: 1.25rem;\r\n}\r\n\r\n.report-label {\r\n    display: flex;\r\n    flex-direction: column;\r\n    font-weight: 600;\r\n}\r\n\r\n.report-textarea {\r\n    margin-top: 0.5rem;\r\n    min-height: 140px;\r\n    padding: 0.75rem;\r\n    font-size: 1rem;\r\n    border: 1px solid #ccc;\r\n    border-radius: 6px;\r\n    resize: vertical;\r\n}\r\n\r\n.report-input {\r\n    margin-top: 0.5rem;\r\n    padding: 0.75rem;\r\n    font-size: 1rem;\r\n    border: 1px solid #ccc;\r\n    border-radius: 6px;\r\n}\r\n\r\n.report-button {\r\n    padding: 0.9rem 1.5rem;\r\n    font-size: 1.1rem;\r\n    background: #0066cc;\r\n    border: none;\r\n    border-radius: 6px;\r\n    cursor: pointer;\r\n}\r\n\r\n    .report-button:disabled {\r\n        opacity: 0.6;\r\n        cursor: default;\r\n    }\r\n\r\n.report-confirmation {\r\n    text-align: center;\r\n    line-height: 1.6;\r\n}\r\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
